import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { ReactComponent as SubmitIcon } from "icons/filter-play.svg";
import { ReactComponent as ResetIcon } from "icons/filter-cross.svg";

const SearchBar = ({
  searchMode,
  textFromProps,
  submitButtonTitle = "",
  clearButtonTitle = "",
  onSubmit,
  onClear,
}) => {
  const [text, setText] = useState(textFromProps);

  useEffect(() => {
    setText(textFromProps);
  }, [textFromProps]);

  const handleChange = (e) => {
    setText(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(text);
  };

  const handleClear = () => {
    setText("");
    onClear();
  };

  return (
    <form
      data-testid="search-bar"
      className="search_bar"
      onSubmit={handleSubmit}
    >
      <input
        value={text}
        type="text"
        placeholder="Type to filter"
        data-testid="search-input"
        onChange={handleChange}
      />
      {!searchMode ? (
        <button
          type="button"
          title={submitButtonTitle}
          disabled={text.trim() === ""}
          data-testid="search-bar--submit-button"
          onClick={handleSubmit}
        >
          <SubmitIcon />
        </button>
      ) : (
        <button
          type="button"
          title={clearButtonTitle}
          data-testid="search-bar--clear-button"
          onClick={handleClear}
        >
          <ResetIcon />
        </button>
      )}
    </form>
  );
};

export default SearchBar;

SearchBar.propTypes = {
  searchMode: PropTypes.bool.isRequired,
  textFromProps: PropTypes.string,
  submitButtonTitle: PropTypes.string,
  clearButtonTitle: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};
